import React, { Component } from "react";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import SwalServices from "../../services/swalServices/SwalServices.js";

class ItemCategory extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      tableStatus: "",
      isLoading: false,
      itemGroupLisitng: [],
      itemGroupDetails: {
        categoryName: "",
      },
    };
  }

  componentDidMount() {
    this.getAllItemGroups();
  }

  getAllItemGroups = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllItemCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { itemGroupLisitng: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditItemGategory = () => {
    if (this.state.itemGroupDetails.categoryName !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.itemGroupDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditItemGategory(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllItemGroups();
            this.resetForm();
            this.setState({ isLoading: false })
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.itemGroupDetails;
    details.categoryName = "";
    this.setState({ itemGroupDetails: details, _id: "", tableStatus: "", isEditing: false });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.itemGroupDetails;
    details[name] = value.toUpperCase();
    this.setState({ itemGroupDetails: details });
  };

  getCategoryById = (group) => {
    let details = this.state.itemGroupDetails;
    details.categoryName = group.categoryName;
    this.setState({ itemGroupDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteCategoryById = (id) => {
    this.itemMasterServices.deleteCategoryById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllItemGroups();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">

        <div className="item-form">
          <div className="form-table">
            <div className="item-grp w-[50%] !mb-3.5">
              <label>Item Group</label>
              <input
                className="inputFocus"
                type="text"
                id="categoryName"
                name="categoryName"
                autoComplete="off"
                value={this.state.itemGroupDetails.categoryName}
                onChange={(event) => this.handleChange(event, "categoryName")}
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditItemGategory()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditItemGategory()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()}
                disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList ">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Item Name</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.itemGroupLisitng &&
                    this.state.itemGroupLisitng.length > 0 ?
                    this.state.itemGroupLisitng.map((group, key) => (
                      <tr key={key}>
                        <td>{group.categoryName}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getCategoryById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteCategoryById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.itemGroupLisitng &&
                      this.state.itemGroupLisitng.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.itemGroupLisitng &&
                      this.state.itemGroupLisitng.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ItemCategory;
